const { forEach, isNull } = require('lodash');

require('./bootstrap');
require('./external-blank');
require('./tag-filtering');
require('./header-size');
// require('./menu');
require('./cookiebar');
